import { Registro } from '../types';
import { config } from '../config';
import { autoCategorizarLote } from '../utils/autoCategorizacion';

const API_URL = `${config.api.baseUrl}/data`;

export const fetchRegistros = async (usePagination = false, page = 1, limit = 50): Promise<Registro[]> => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No se encontró el token de autenticación');
    }

    // Construir URL con o sin paginación
    let url = `${API_URL}?_=${Date.now()}`;
    if (usePagination) {
      url += `&paginated=true&page=${page}&limit=${limit}`;
    }

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('No autorizado. Por favor, inicie sesión nuevamente.');
      }
      throw new Error(`Error HTTP: ${response.status}`);
    }

    const result = await response.json();

    if (!result.datos) {
      return [];
    }

    // Asegurarnos de que todos los registros tengan una incidencia
    const registrosConIncidencias = result.datos.map((registro: any) => ({
      ...registro,
      incidencia: registro.incidencia || 'Sin novedad',
    }));

    // ✨ NUEVO: Auto-categorizar registros sin categoría
    const registrosCategorizados = autoCategorizarLote(registrosConIncidencias);

    // console.log('Datos recibidos y auto-categorizados:', registrosCategorizados);
    return registrosCategorizados;
  } catch (error) {
    // console.error('Error al obtener registros:', error);
    throw error;
  }
};

// Nuevo: obtener categorías dinámicamente desde el backend
export const fetchCategorias = async (): Promise<string[]> => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No se encontró el token de autenticación');
    }
    // Asegura que nunca use caché
    const response = await fetch(`${config.api.baseUrl}/categorias?nocache=${Date.now()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Error al obtener categorías');
    }
    const result = await response.json();
    // Ajusta según el formato de respuesta de tu backend
    return result.categorias || [];
  } catch (error) {
    // console.error('Error al obtener categorías:', error);
    return [];
  }
};

export const actualizarCategoria = async (id: number, categoria: string | null): Promise<void> => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No se encontró el token de autenticación');
  const response = await fetch(`${config.api.baseUrl}/data/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ categoria }),
  });

  let data: any = {};
  try {
    data = await response.json();
  } catch {
    // Si no es JSON válido, deja data vacío
  }

  if (!response.ok || data.success === false) {
    throw new Error(data.error || 'Error al actualizar la categoría');
  }
};

// Nuevo: borrar la categoría de un registro (DELETE /api.php/data/{id}/categoria)
export const borrarCategoria = async (id: number): Promise<void> => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No se encontró el token de autenticación');
  const response = await fetch(`${config.api.baseUrl}/data/${id}/categoria`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  if (!response.ok || data.success === false) {
    throw new Error(data.error || 'Error al borrar la categoría');
  }
};
